import fetchApi from './api';
import { ApiResponse, LoginResponse, SearchPaging } from 'models/model';
import fetchApiBlob from './apiBlob';

const API_BASE_URL = process.env.NEXT_PUBLIC_API_BASE_URL || '';

export const ExamResultSaveList = async (
	courseId: string,
	data: any[]
): Promise<ApiResponse> => {
	return fetchApi<ApiResponse>(`/ExamResult/SaveList?courseId=${courseId}`, {
		method: 'POST',
		body: JSON.stringify(data),
	});
};

export const ExamResultGetList = async (data: any): Promise<ApiResponse> => {
	return fetchApi<ApiResponse>('/ExamResult/GetList', {
		method: 'POST',
		body: JSON.stringify(data),
	});
};

export const ExamResultImport = async (
	courseId: string,
	file: File
): Promise<ApiResponse> => {
	const formData = new FormData();
	formData.append('File', file);
	formData.append('CourseId', courseId);

	return fetchApi<any>(`/ExamResult/Import`, {
		method: 'POST',
		body: formData,
		headers: {
			Accept: 'application/json',
		},
	});
};
export const ExamResultImportListCourseExam = async (
	file: File
): Promise<ApiResponse> => {
	const formData = new FormData();
	formData.append('File', file);

	return fetchApi<any>(`/ExamResult/ImportListCourseExam`, {
		method: 'POST',
		body: formData,
		headers: {
			Accept: 'application/json',
		},
	});
};

export const ExamResultExport = async (id: string): Promise<any> => {
	return fetchApiBlob('/ExamResult/Export', {
		body: JSON.stringify({ id }),
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			Accept: 'application/json',
		},
	});
};

export const ExportListCourseExam = async (ids: string[]): Promise<any> => {
	return fetchApiBlob('/ExamResult/ExportListCourseExam', {
		body: JSON.stringify(ids),
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			Accept: 'application/json',
		},
	});
};
